/**
 * @internal
 */
export enum DialogPaths {
    quickDialog = 'dist/quickDialog/', // quick-dialog
    eavUi = 'dist/ng-edit/', // Angular
}
